import { createApp } from "vue";
import ComponentLoader from "@/../core/component-loader.vue";
import PrimeVue from "primevue/config";
import { getPrimevueConfig } from "@/../config/primevue";
import { AppRootEnum } from "./app-root-enum";

const useVue = () => {
    useDynamicComponents();
};

function useDynamicComponents() {
    const roots = document.querySelectorAll("[data-vue]");

    for (const root of roots) {
        loadComponent(root as HTMLElement);
    }
}

function loadComponent(node: HTMLElement) {
    const componentName = node.getAttribute("data-vue");
    const showLoader = !node.classList.contains("disable-loader");
    const appRoot = node.getAttribute("data-app-root") as AppRootEnum;

    // pass data-attributes as props
    const dataset = node.dataset;
    const dataProps: Record<string, string | number | boolean> = {};
    Object.keys(dataset)
        .filter((x) => !["vapp", "vue", "loader"].includes(x.toLowerCase()))
        .forEach((p) => {
            let val: string | number | boolean = dataset[p];
            if (val === "false" || val === "False") {
                val = false;
            } else if (val === "true" || val === "True") {
                val = true;
            }
            dataProps[p] = val;
        });

    const component = createApp(ComponentLoader, { componentName, showLoader, dataProps, appRoot });
    component.use(PrimeVue, getPrimevueConfig());
    component.mount(node);
}

export { useVue };
